"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vue = require("@handsontable/vue");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _indexHotOpt = _interopRequireDefault(require("./components/indexHotOpt"));
var _booking = require("@/api/bookSpace/booking");
var _utils = require("@/utils");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "bookingSpaceList",
  components: {
    HotColumn: _vue.HotColumn,
    HotTable: _vue.HotTable,
    Pagination: _Pagination.default,
    customRenderer: _indexHotOpt.default
  },
  data: function data() {
    return {
      sortFlag: true,
      checkPol: true,
      listQuery: {
        etdTo: "",
        pol: "",
        pod: "",
        etd: "",
        currentPage: 1,
        pageSize: 100,
        vesselCode: "",
        voyageNo: "",
        voyageLeg: "",
        eta: "",
        etaTo: "",
        serviceLineCode: "",
        isTs: "0",
        pot: "",
        por: "",
        time: ''
      },
      filterForm: {
        keyword: '',
        portOfDeparture: '',
        radio: '1',
        selectTime: '2',
        serviceLineCode: ''
      },
      options: [{
        value: '1',
        labelZh: '及后一周内',
        labelEh: '+1 Week'
      }, {
        value: '2',
        labelZh: '及后两周内',
        labelEh: '+2 Weeks'
      }, {
        value: '3',
        labelZh: '及后三周内',
        labelEh: '+3 Weeks'
      }, {
        value: '4',
        labelZh: '及后四周内',
        labelEh: '+4 Weeks'
      }],
      total: 0,
      tableData: [],
      tableLoading: false,
      rules: {
        pol: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'change'
        }],
        pod: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'change'
        }],
        time: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'blur'
        }],
        por: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'change'
        }]
      },
      hotSettings: {
        dragCheck: true,
        height: 'calc(100vh - 215px)',
        width: '100%',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        columnSorting: true,
        showSelection: false,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      isShow: true
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])), {}, {
    dynamicWidth: function dynamicWidth() {
      return this.language === 'en' ? '200' : '150';
    }
  }),
  created: function created() {
    // this.$dictionary.get(['BIZ_EST_TYPE'], true).then((res) => {
    //   res = JSON.parse(JSON.stringify(res))
    //   this.estimateTypeList = res.BIZ_EST_TYPE ? res.BIZ_EST_TYPE : []
    // })
    // this.handleSearch();
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.resizeHotTable();
      // 获取当前时间
      _this.handleGetTime();
    });
  },
  methods: {
    parseTime: _utils.parseTime,
    handleGetTime: function handleGetTime() {
      if (this.filterForm.radio === '1') {
        this.listQuery.time = (0, _utils.parseTime)(new Date(), '{y}-{m}-{d}');
      } else {
        var oneDay = 24 * 60 * 60 * 1000;
        this.listQuery.time = new Date().getTime() + 7 * oneDay;
      }
    },
    toogleExpand: function toogleExpand(row) {
      if (this.listQuery.isTs == '1') {
        row.flag = !row.flag;
        var $table = this.$refs.table;
        this.tableData.map(function (item) {
          if (row.id != item.id) {
            $table.toggleRowExpansion(item, false);
          }
        });
        $table.toggleRowExpansion(row);
      }
    },
    handleSelectVessel: function handleSelectVessel() {
      this.handleSearch();
    },
    // 判断有没有通告
    handleCheck: function () {
      var _handleCheck = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(row, type) {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                pol: row.polHidden,
                singleContainerFlag: type
              };
              _context.next = 3;
              return this.$store.dispatch('isSaveTip/checkQuery', data);
            case 3:
              this.checkDtaParams = _context.sent;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCheck(_x, _x2) {
        return _handleCheck.apply(this, arguments);
      }
      return handleCheck;
    }(),
    handleCheckSubmit: function handleCheckSubmit() {
      this.$refs.checkNotice.checkVisible = false;
      this.$router.push({
        path: '/bookingSpace/bookingSpaceDetail',
        query: {
          bookingInfo: JSON.stringify(this.rowData)
        }
      });
    },
    // 新增订舱
    handleAddBooking: function () {
      var _handleAddBooking = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(row) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              row.extend = false;
              this.rowData = row;
              console.log(this.rowData, '订舱');
              _context2.next = 5;
              return this.handleCheck(row, 0);
            case 5:
              if (this.checkDtaParams && Object.keys(this.checkDtaParams).length) {
                this.$refs.checkNotice.checkVisible = true;
              } else {
                this.$router.push({
                  path: '/bookingSpace/bookingSpaceDetail',
                  query: {
                    bookingInfo: JSON.stringify(this.rowData)
                  }
                });
              }
              console.log(this.rowData, '订舱');
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleAddBooking(_x3) {
        return _handleAddBooking.apply(this, arguments);
      }
      return handleAddBooking;
    }(),
    changePort: function changePort(selectedRows) {
      this.form.pol = selectedRows.portCode;
    },
    convertHoursToDaysAndHours: function convertHoursToDaysAndHours(hours) {
      var days = Math.floor(hours / 24);
      var remainingHours = hours % 24;
      return days + '  ' + this.$t('voyagePlanSearch.day') + '  ' + remainingHours + '  ' + this.$t('voyagePlanSearch.hour');
    },
    handleOpen: function handleOpen() {
      // this.$router.push({path:'/portContacts'})
      var routeUrl = this.$router.resolve({
        path: '/portContacts'
      });
      window.open(routeUrl.href, '_blank');
    },
    changeSelect: function changeSelect(val) {
      this.caculateTime(this.listQuery.time);
    },
    handleReset: function handleReset() {
      for (var key in this.listQuery) {
        this.listQuery[key] = '';
      }
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 100;
      this.listQuery.isTs = '0';
      this.listQuery.time = '';
      this.filterForm.selectTime = '2';
      this.filterForm.serviceLineCode = '';
      this.filterForm.vesselCode = '';
      this.filterForm.radio = '1';
      this.handleGetTime();
    },
    getValue: function getValue(val) {
      this.handleGetTime();
      this.lastTime();
    },
    getValueTranster: function getValueTranster(val) {
      val === '1' ? this.listQuery.por = this.listQuery.pol : this.listQuery.por = '';
    },
    changeTime: function changeTime(val) {
      console.log(val, '时间的惦');
      this.caculateTime(val);
    },
    caculateTime: function caculateTime(val) {
      if (val) {
        var mapObject = {
          '1': 7,
          '2': 14,
          '3': 21,
          '4': 28
        };
        var day = mapObject[this.filterForm.selectTime];
        console.log(val, '时间的惦222');
        var date = new Date(val);
        console.log(date, '时间的惦111');
        var timestamp = date.getTime();
        var oneDay = 24 * 60 * 60 * 1000;
        var newTimestamp = timestamp + day * oneDay;
        this.newDate = new Date(newTimestamp);
        console.log(this.newDate, val, '两周后的时间', day);
        this.lastTime();
      } else {
        this.listQuery.eta = '';
        this.listQuery.etaTo = '';
        this.listQuery.etd = '';
        this.listQuery.etdTo = '';
      }
    },
    lastTime: function lastTime() {
      if (this.filterForm.radio === '1') {
        this.listQuery.etd = (0, _utils.parseTime)(this.listQuery.time, '{y}-{m}-{d}');
        this.listQuery.etdTo = (0, _utils.parseTime)(this.newDate, '{y}-{m}-{d}');
        this.listQuery.eta = '';
        this.listQuery.etaTo = '';
      } else {
        this.listQuery.eta = (0, _utils.parseTime)(this.listQuery.time, '{y}-{m}-{d}');
        this.listQuery.etaTo = (0, _utils.parseTime)(this.newDate, '{y}-{m}-{d}');
        this.listQuery.etd = '';
        this.listQuery.etdTo = '';
      }
    },
    handleSearch: function handleSearch() {
      var _this2 = this;
      this.$refs['listQuery'].validate( /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(valid) {
          var data;
          return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!valid) {
                  _context3.next = 13;
                  break;
                }
                _context3.next = 3;
                return _this2.$store.dispatch('isSaveTip/checkPol', _this2.listQuery.pol);
              case 3:
                _this2.checkPol = _context3.sent;
                _this2.caculateTime(_this2.listQuery.time);
                data = Object.assign({}, _this2.listQuery);
                delete data.time;
                data.vesselCode = _this2.filterForm.vesselCode;
                data.serviceLineCode = _this2.filterForm.serviceLineCode;
                _this2.tableLoading = true;
                (0, _booking.queryVoyagePlanPage)(data).then(function (res) {
                  if (res.success) {
                    res.data && res.data.records.map(function (item, index) {
                      return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, item), {}, {
                        flag: false
                      });
                    });
                    _this2.tableData = res.data && res.data.records;
                    _this2.total = res.data && res.data.totalRecord;
                  }
                  _this2.tableLoading = false;
                });
                _context3.next = 14;
                break;
              case 13:
                return _context3.abrupt("return", false);
              case 14:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleAdd: function handleAdd() {
      this.id = '';
      this.initDialogVisible = true;
      this.disabledType = false;
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTable && this.$refs.hotTable.resizeTo();
    },
    searchFn: function searchFn(val) {
      this.listQuery.currentPage = val.page;
      this.listQuery.pageSize = val.limit;
      this.handleSearch();
    },
    handleDouble: function handleDouble(_ref2) {
      var physicalRow = _ref2.physicalRow;
      this.handleEdit(physicalRow);
    },
    handleViewContract: function handleViewContract(row) {
      var data = this.tableData[row];
      this.id = data.id;
      this.disabledType = true;
      this.initDialogVisible = true;
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(row) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              row.extend = true;
              this.rowData = row;
              _context4.next = 4;
              return this.handleCheck(row, 1);
            case 4:
              console.log(this.rowData, '订舱推广');
              if (row.slotControlStatus == '1' && row.polHidden == 'CNSHK' && row.status !== '1' && this.checkPol) {
                if (this.checkDtaParams && Object.keys(this.checkDtaParams).length) {
                  this.$refs.checkNotice.checkVisible = true;
                } else {
                  this.$router.push({
                    path: '/bookingSpace/bookingSpaceDetail',
                    query: {
                      bookingInfo: JSON.stringify(this.rowData)
                    }
                  });
                }
              }
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleEdit(_x5) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    setInitDialogVisible: function setInitDialogVisible(val) {
      this.initDialogVisible = val;
    },
    columnRenderer: function columnRenderer(instance, td, row, col, prop, value, cellProperties) {
      Handsontable.renderers.TextRenderer.apply(this, arguments);
      if (value) {
        td.setAttribute('title', value);
        td.innerHTML = value;
      } else {
        td.innerHTML = "";
      }
    }
  }
};